DYC.factory('service', function() {
    var factory = {
        expand: function(attr, fn) {
            this[attr] = fn();
        }
    };
    return factory;
});


// WEBPACK FOOTER //
// ./src/common/service/service.js